import { render, staticRenderFns } from "./ClientTableRow.vue?vue&type=template&id=44b5f76a&scoped=true"
import script from "./ClientTableRow.vue?vue&type=script&lang=ts"
export * from "./ClientTableRow.vue?vue&type=script&lang=ts"
import style0 from "./ClientTableRow.vue?vue&type=style&index=0&id=44b5f76a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b5f76a",
  null
  
)

export default component.exports